<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="title">
      <h1>
        <i class="pi pi-link cooperation-icon"></i> 官民連携チャットルーム通報審査
      </h1>
    </div>

    <!-- 検索ボタン -->
    <button
      pButton
      type="button"
      label="検索"
      class="button1 search-button"
      (click)="getResultTaskDataList()"
    ></button>

    <!-- 検索条件入力 -->
    <div class="search-form-area" [formGroup]="secretariatSearchForm">
      <div class="p-d-flex p-jc-between item-div">
        <!-- 検索テキスト -->
        <!-- ステータス -->
        <div class="item">
          <label class="item-span">ステータス</label>
          <p-dropdown
            [options]="statusList"
            optionLabel="sp_name"
            optionValue="sp_code"
            [showClear]="true"
            styleClass="information-Form-dropdown"
            formControlName="status"
          ></p-dropdown>
        </div>

        <!-- 更新日時 -->
        <div class="item-flex">
          <label class="item-span">更新日時</label>
          <p-calendar
            [showIcon]="true"
            [showButtonBar]="true"
            [yearNavigator]="true"
            [monthNavigator]="true"
            placeholder=""
            dateFormat="yy/mm/dd"
            dataType="string"
            appendTo="body"
            yearRange="2000:2999"
            formControlName="date1"
            translate
          ></p-calendar>
          <div class="verticalTilde">〜</div>
          <p-calendar
            [showIcon]="true"
            [showButtonBar]="true"
            [yearNavigator]="true"
            [monthNavigator]="true"
            placeholder=""
            dateFormat="yy/mm/dd"
            dataType="string"
            appendTo="body"
            yearRange="2000:2999"
            formControlName="date2"
            translate
          ></p-calendar>
        </div>
      </div>
    </div>

    <!-- 結果表示 -->
    <div class="result-area">
      <!-- ページアンカー -->
      <a id="jump-top"></a>
      <!-- 検索結果数 -->
      <div class="result-count-area">
        <label class="count"> {{ resultTaskDataList.length }} </label>
        件
      </div>
      <!-- リスト表示 -->
      <p-table
        #table
        [value]="resultTaskDataList"
        [paginator]="true"
        [rows]="100"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
        [rowsPerPageOptions]="[10, 50, 100, 500, 1000]"
        emptyMessage="データが存在しません"
        selectionMode="single"
        styleClass="list-area"
        (onPage)="jumpTop()"
      >
        <ng-template pTemplate="header">
          <tr>
            <!-- Noは自治体の時のみ表示 -->
            <th class="report_id" pSortableColumn="report_id">通報ID<p-sortIcon field="report_id"></p-sortIcon></th>
            <th class="organization_name" pSortableColumn="organization_name">通報者会員<p-sortIcon field="organization_name"></p-sortIcon></th>
            <th class="target_type" pSortableColumn="target_type">通報対象<p-sortIcon field="target_type"></p-sortIcon></th>
            <th class="contents" pSortableColumn="contents">内容<p-sortIcon field="contents"></p-sortIcon></th>
            <th class="reason" pSortableColumn="reason">通報理由<p-sortIcon field="reason"></p-sortIcon></th>
            <th class="status" pSortableColumn="status.id">ステータス<p-sortIcon field="status.id"></p-sortIcon></th>
            <th class="update_datetime" pSortableColumn="update_datetime">更新日時<p-sortIcon field="update_datetime"></p-sortIcon></th>
            <th class="create_datetime" pSortableColumn="create_datetime">申請日時<p-sortIcon field="create_datetime"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-resultTaskDataList>
          <tr class="list" (click)="moveD262(resultTaskDataList.report_id)">
            <!-- Noは自治体の時のみ表示 -->
            <!-- 通報ID -->
            <td>
              {{ resultTaskDataList?.report_id }}
            </td>
            <!-- 通報者会員 -->
            <td>
              {{ resultTaskDataList?.organization_name }} ({{ resultTaskDataList?.class_name }})
            </td>
            <!-- 通報対象 -->
            <td>
              <ng-container *ngIf="resultTaskDataList?.target_type === '1'">スレッド</ng-container>
              <ng-container *ngIf="resultTaskDataList?.target_type === '2'">書き込み</ng-container>
            </td>
            <!-- 内容 -->
            <td>
              {{ resultTaskDataList?.target_content }}
            </td>
            <!-- 通報理由 -->
            <td>
              {{ resultTaskDataList?.reason }}
            </td>
            <!-- ステータス -->
            <td [class.denial]="1 == resultTaskDataList.status.id">
              {{ resultTaskDataList?.status.name }}
            </td>
            <!-- 更新日時 -->
            <td>
              {{ convertToJST(resultTaskDataList?.update_datetime) }}
            </td>
            <!-- 申請日時 -->
            <td>
              {{ convertToJST(resultTaskDataList?.create_datetime) }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
